/**
 * 장비 기종/옵션 윈도우 공통모듈 (BS)
 * 데이터 처리
 */
import Util from '../../../Common/Util';

/** 배열에 없으면 넣고 있으면 뺀다. 옵션·규격 다중선택 토글에 쓴다 (Ladder 도 씀) */
export function arrayToggle(arr, v) {
    return arr.includes(v) ? arr.filter(item => item != v) : [...arr, v];
}

/** 콤마구분 문자열 → 배열 (빈값 제거). 옵션값이 'a,b,' 처럼 꼬리콤마로 오는 걸 흡수한다 */
function stringToArray(str) {
    if (!str) return [];
    return String(str).split(',').filter(v => v !== '');
}

export default class OptionWindow {
    constructor() {
        // ['스카이','사다리','크레인','지게차','굴삭기','리프트'],
        this.config = {
            '스카이': '$j.F.Baljoo.ModalOptionSky',
            '사다리': '$j.F.Baljoo.ModalOptionLadder',
            '크레인': '$j.F.Baljoo.ModalOptionCrane',
            '지게차': '$j.F.Baljoo.ModalOptionForklift',
            '굴삭기': '$j.F.Baljoo.ModalOptionExcavator',
            '리프트': '$j.F.Baljoo.ModalOptionLift',
        };
        this.classInstance = {};
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    /**
     * 내부 변수 초기화
     * @param isAll true(업종이 변경될때), false(메인버튼이 해제될때)
     */
    reset(isAll=false){
        if( isAll) {
            this.id = null;
            this.win = null; // 장비윈도우 ( 예 : OptionSkyWindow 등을 가리킨다.)
            this.data = null; // ORDER 데이터
        }
        this.mainIdx = 0; // 메인버튼의 인덱스값
        this.mainFunc = ''; // 메인버튼에 관련된 서브버튼의 동작방식
        this.subIdxRangeLimit = []; // 메인버튼에 따른 서브버튼의 범위 [최소,최대]
        this.subIdxList = []; // 서브버튼인덱스 배열
        this.subCounter=0; // 서브버튼을 클릭한 횟수(스카이 1T 선택후 16M 를 한번 눌렀으면 1, 두번누르면 2 ..)
    }
    /**
     * 차종별 옵션 모달 HTML 을 반환한다.
     * @param data ORDER 데이터 (car_type 사용)
     */
    getHtml = function(data){
        const car_type = data?.['car_type'] || '';
        const classInstanceName = this.config[car_type];
        if( !classInstanceName) return '<div id="window-option" class="car_option"></div>';
        const classRef = eval(classInstanceName);
        if( !classRef || typeof classRef.getHtml !== 'function') return '<div id="window-option" class="car_option"></div>';
        return `<div id="window-option" class="car_option">${classRef.getHtml()}</div>`;
    }
    /**
     * 디버깅 정보를 표시한다.
     */
    showDebug = ()=>{
        console.log('OptionInfo ==> ',{
            'mainIdx': this.mainIdx,
            'mainFunc': this.mainFunc,
            'subIdxList': this.subIdxList,
            'subIdxRangeLimit': this.subIdxRangeLimit,
            'subCounter': this.subCounter,
            'data': this.data
        });
    }
    init = function() {
        // BS 가 주입한 id/data 는 reset 대상이 아니므로 보존
        const id = this.id;
        const data = this.data;
        this.reset(true);
        this.id = id;
        this.data = data;
        this.subCounter = 2;

        this.parent.setTitle('기종/옵션');
        $('#' + this.id).html(this.getHtml(data));

        const car_type = data['car_type'];
        const classInstanceName = this.config[car_type];
        if(!classInstanceName) return;

        const classRef = eval(classInstanceName);
        this.classInstance[car_type] = classRef;
        this.win = classRef;
        this.win.init(this);

        // 제원표/옵션 이미지 클릭 → ZoomPhoto
        $('#'+this.id).off('click.option-zoom').on('click.option-zoom', '.js-zoom-img', function(){
            const src = $(this).attr('src');
            if (src) $j.Ui.ZoomPhoto.open(src);
        });
    }
    destroy() {
        $('#' + this.id).off('click.option-zoom');
    }
    /**
     * 장비대금을 계산한다.
     */
    calcPrice = ()=>{
        const self = this;
        const od = this.data;
        const data = {
            'car_type': od['car_type'],// 업종
            'car_range': od['car_range'],// 범위
            'car_workhour': od['car_workhour'],// 작업시간
            'car_workdaytype': od['car_workdaytype'],// 작업시간단위
            'car_workaddtype': od['car_workaddtype'],// 추가시간
            'car_workaddhor': od['car_workaddhor'],//추가작업시간단위
            'car_option': od['car_option'],// 옵션
            'work_start_h': od['work_start_h'],//시작시간
            'work_day': od['work_day'],//작업일
            'sosok': od['order_sosok'],
            // 저단가 하한은 어플발주만 — 수정이면 원 오더 종류, 신규·복사는 버튼 전이라 빈 값(=대상)
            'order_type': editMode == 'myorderedit' ? od['order_type'] : '',
        };
        $j.F.Car.calcPrice(data,function(out){
            // console.log('price =======> ',out);
            // 저단가 하한은 톤수 구간(3.5톤이하/5톤)마다 다르다 — 톤수를 바꾸는 게 이 모달이므로
            // 응답마다 새로 받아둔다. 안 그러면 열었을 때의 옛 구간 하한으로 판정한다.
            self.data['sky_low_limit'] = out['sky_low_limit'];
            self.drawPrice(out);
        });
    }

    /**
     * 기존에 선택한 값을 로드해야할때 car_range 값으로부터 변수값(mainIdx, subIdxList, subIdxRangeLimit)을 초기화한다.
     * 추가발주하거나 기종선택후 다시 띄웠을때 선택한값이 보여야할때
     */
    load = function(){
        console.log("Option load ...");
        const self = this;
        const data = this.data;
        const car_type = data['car_type'];
        const car_range = data['car_range'];
        if(!car_range) return;
        console.log('car_range -----> ', car_range);

        let arr = car_range.split('|');
        const tonRange = arr[0];
        const meterRange = arr[1];
        let frCode='';
        let toCode='';
        let codeList = [];
        let tonCode = '';

        let idx='';
        let code = '';
        let range = '';
        let idxRangeMap = {}; // index - range 매핑

        // 메인버튼 순회하면서 index-range 매핑 배열을 완성한다.
        $('#'+this.id+" .main-button-area .item").each(function(){
            idx = $(this).attr('data-index');
            range = $(this).attr('data-range');
            idxRangeMap[idx]=range;
        });
        console.log(idxRangeMap);

        // 기종범위
        if( tonRange ){
            // 범위검색
            if( tonRange.indexOf(',')==-1){
                arr = tonRange.split('~'); // 340~342
                frCode=arr[0];// 340
                toCode=arr[1];// 342

                if( car_type=='스카이') tonCode=frCode;
            }
            // 개별검색
            else{
                codeList = tonRange.split(',');//530,534
            }
        }
        // 미터범위
        if( meterRange ){
            const list = meterRange.split('~');
            frCode = list[0];
            toCode = list[1];
        }

        //=================
        // 메인 버튼 (스카이만 해당)
        //=================
        if( tonCode ){
            $('#' + this.id + " .main-button-area .item").each(function () {
                if( $(this).attr('data-code')==tonCode ){
                    self.mainIdx = $(this).attr('data-index');
                }
            });
        }

        //=================
        // 서브 버튼
        //=================
        console.log('load, sub-button', codeList, frCode, toCode);
        if( frCode ){ // 범위 선택의 경우
            console.log(frCode, toCode);
            let isRangeStarted = false;
            let isRangeEnded = false;
            $('#' + this.id + " .sub-button-area .item").each(function () {
                if (isRangeEnded) return;

                idx = $(this).attr('data-index');
                code = $(this).attr('data-code');
                if (!idx) return;
                // console.log(idx,code);

                if (isRangeStarted) {
                    self.subIdxList.push(idx);

                    if (code == toCode) {// 범위종료
                        isRangeEnded = true;
                        return;
                    }
                } else {
                    if (code == frCode) {// 범위시작
                        if(!self.mainIdx) {// 스카이는 이미 mainIdx 값을 가지고 있으므로 스킵
                            self.mainIdx = $(this).parent().attr('data-index');
                        }
                        self.subIdxList.push(idx);
                        self.subIdxRangeLimit = idxRangeMap[self.mainIdx].split('~');
                        isRangeStarted = true;
                        if (!toCode || frCode==toCode) { // 단일범위인 경우
                            isRangeEnded = true;
                        }
                        return;
                    }
                }
            });
        }
        else{ // 개별 버튼 선택의 경우
            $('#' + this.id + " .sub-button-area .item").each(function () {
                idx = $(this).attr('data-index');
                code = $(this).attr('data-code');
                if( codeList.includes(code)){
                    self.subIdxList.push(idx);
                    if(!self.mainIdx){
                        self.mainIdx = $(this).parent().attr('data-index');
                        self.subIdxRangeLimit = idxRangeMap[self.mainIdx].split('~');
                    }
                }
            });
        }

        // 가격 계산
        this.calcPrice();

        this.showDebug();
    }

    /**
     * 화면을 새로그려준다.
     */
    draw = function(){
        this.drawRange();
        this.drawOptions();
        this.drawExample();
    }

    /**
     * 제원표를 그린다.
     */
    drawExample = function(){
        const self = this;
        const arr = this.subIdxList;
        const fr = arr.length ? Math.min(...arr) : 0; // 서브버튼 선택한 인덱스 최소값
        let carCode = '';
        let carName = '';
        let opts = [];

        // 서브버튼 순회
        $('#'+this.id+" .sub-button-area .item").each(function(){
            if($(this).parent().data('index')!=self.mainIdx) return true;
            if($(this).data('index')!=fr) return true;
            if($(this).data('example')!=1) return true; // 장비.blade.php 에서 data-example="1" 로 하면 제원표 이미지 보인다.

            carCode = $(this).data('code');
            carName = $j.F.Car.getNameFromCode(carCode);
            return false;
        });

        // 옵션버튼 순회
        $('#'+this.id+' .option .item').each(function() {
            if (!$(this).hasClass('on')) return true; // continue;
            if ($(this).data('example')!=1) return true; // continue;
            opts.push( [$(this).data('code'), $(this).data('value')] );
        });

        if( !fr && opts.length==0 ) return;

        // 계산에 필요한 변수들
        var ww = $(window).width();
        var thf = parseInt(ww / 3.2);// 3등분
        let x = 1.5;
        if( opts.length<2) x = 1.8;
        let h = parseInt(thf / x); // 옵션 이미지 높이

        // 기종 이미지
        let td1 = '';
        if( carCode ){
            td1 = `
            <td style='vertical-align:top'>
                <img src='/img/data/car_info/${carCode}.png' style='width:${thf}px; vertical-align:top;cursor:pointer' data-title="${carName}" class="js-zoom-img">
            </td>`;
        }
        // 옵션이미지
        let td2 = '';
        if( opts.length ){
            let str = '';
            for (let i = 0; i < opts.length; i++) {
                let [ c, v ] = opts[i];
                str += `<img src='/img/data/car_option/${c}.png' style='height:${h}px;cursor:pointer' data-title="${v}" class="js-zoom-img">`;
                if ((i+1) % 3 == 0) str += "<br>";
            }
            td2 = `<td style='vertical-align:top;text-align:left'>${str}</td>`;
        }

        let htm = `
        <table style='margin:0px auto'>
            <tr>
                ${td1}
                ${td2}
            </tr>
        </table>`;

        $('#'+this.id+' .car-example').html(htm);
    }

    /**
     * 가격 정보를 표시한다.
     */
    drawPrice(data){
        // console.log('drawPrice --> ',this.data);
        let label = '소요시간';
        const d = {...this.data};
        if( !d['car_workhour']){
            d['car_workhour']=1;
            d['car_workdaytype']='일';

            if( d['car_type']=='사다리') {
                d['car_workdaytype']='톤';
                label='짐량';
            }

        }
        let title = `장비대금 : ${Util.formatNumber(data['price'])}원`;
        let text = `${label} : ${$j.F.Car.getWorkHourStr(d)}`;

        // 저단가면 알림 자체를 경고로 바꾼다 (2026-09-01~). 이 모달에서 톤수를 내리면 하한 아래로
        // 떨어질 수 있는데, 발주화면의 금액칸 경고(.is-lowprice)는 모달을 닫아야 보인다.
        if ($j.F.Car.isSkyLowWarn({ car_price: data['price'], sky_low_limit: data['sky_low_limit'] })) {
            $j.Ui.Toast.show(`저단가 · ${title} (하한 ${Util.formatNumber(Util.int(data['sky_low_limit']))}원)`,
                { type: 'warning', timeout: 4000, closable: true });
            return;
        }

        // 한 줄로 붙인다 — 두 조각을 합쳐도 250px 남짓이라 토스트 한도(폰에서 367px) 안에 든다.
        // <br> 로 끊으면 폭이 남는데도 늘 두 줄이 되어 알약이 커 보인다.
        $j.Ui.Toast.show(`${title} · ${text}`, { type: 'success', timeout: 3000, closable: true });
    }
    /**
     * 기종범위를 그려준다.
     * @param data
     */
    drawRange = function(){
        const self = this;
        // 메인 버튼 그리기
        $('#'+this.id+" .main-button-area .item").each(function(idx,el){
            if( $(el).attr('data-index')==self.mainIdx ) $(el).addClass('on');
            else $(el).removeClass('on');
        });

        // 서브 버튼 그리기
        $('#'+this.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if(!idx) return;

            if( self.subIdxList.includes(idx) ) $(this).addClass('on');
            else $(this).removeClass('on');
        });
    }
    /**
     * 전고 <option> 을 채운다.
     */
    drawJungo = function(){
        let html='';
        for(let i=40;i>=23;i--){
            let v = (i/10).toFixed(1);
            let t = v;
            if( i==40) t+=' 이하';
            html+=`<option value="${v}">${t}</option>`;
        }

        $('#'+this.id+" .option select[data-value='전고'] option:not(:first)").remove();
        $('#'+this.id+" .option select[data-value='전고']").append(html);
    }

    /**
     * 옵션 버튼,select 표시
     */
    drawOptions = function(){
        const self = this;
        console.log(this.data);
        let opts = stringToArray(this.data['car_option']);
        // console.log(opts);

        // 버튼식 옵션 (예: 덤프, 인증)
        $('#'+this.id+" .option .item").each(function(idx,el){
            if( opts.includes($(el).attr('data-value')) ) $(el).addClass('on');
            else $(el).removeClass('on');
        });

        // selectbox 형식 옵션 ( 예: [하차],[상차] )
        $('#'+this.id+' .option select option').each(function(idx,el){
            const k = $(el).parent().attr('data-value');
            const v = $(el).val();
            // console.log(k, v);

            if( k=='전고') {
                if( self.data['car_height']==v) $(el).prop("selected", true);
            }
            // else if( k=='고릴라') {
            //     if( self.data['crain_gorilaset']==v) $(el).prop("selected", true);
            // }
            else if( k=='이동거리') {
                if( self.data['move_distance']==v) $(el).prop("selected", true);
            }
            else {
                if( opts.includes(`[${v}]`)) $(el).prop("selected", true);
            }
        });
    }
    /**
     * 메인버튼 핸들러
     * 메인버튼은 data-index , data-range(서버버튼 index 의 범위) 값을 가지고있다. 추가속성은 장비별로 다르다.
     */
    initMainButtonHandler = function(){
        const self = this;
        $('#'+this.id+' .main-button-area .item').off().on('click',function(){
            const idx = $(this).data('index');
            const range = $(this).data('range');
            const func = $(this).data('func');
            if( self.mainIdx==idx ) {// 눌렀던거 또 누르면 토글
                self.reset(false);
                self.draw();


                return;
            }
            self.mainIdx = idx;
            self.mainFunc=func;
            self.subIdxRangeLimit=range.split('~');
            self.subIdxList=[];
            self.subCounter=0;

            // 해당 라인에 있는 모든 버튼 배열에 넣기
            $('#'+self.id+' .sub-button-area > div').each(function(){
                if(self.mainIdx!=$(this).attr('data-index')) return; // 해당라인이 아니면 스킵

                $(this).find('.item').each(function(){
                    const idx = $(this).attr('data-index');
                    if(!idx) return;
                    self.subIdxList.push(idx);
                });
            });
            console.log('11212121212121212121');
            self.showDebug();
            self.draw();
            self.win.updateRange();
            self.calcPrice();
        });
    }
    /**
     * 서브버튼 클릭 핸들러
     * 서브버튼은 data-index 를 가지고있다. 추가속성은 장비별로 다르다.
     */
    initSubButtonHandler = function(){
        const self = this;
        $('#'+this.id+' .sub-button-area .item').off().on('click',function(){
            const mainIdx = $(this).parent().data('index');// 클릭한버튼의 메인인덱스
            const subIdx = $(this).data('index');// 클릭한버튼의 서브인덱스
            const subFunc = self.mainFunc;//메인버튼에 연결된 서브버튼의 동작방식
            console.log('sub-button click > ', mainIdx, '>', subIdx);

            // 메인버튼을 선택하지 않았다면 스킵
            if( !mainIdx ) return;

            const min = Util.int(self.subIdxRangeLimit[0]); // 서브버튼 가용범위 인덱스 최소값
            const max = Util.int(self.subIdxRangeLimit[1]); // 서브버튼 가용범위 인덱스 최대값
            console.log('가용범위', min, max);
            console.log('현재버튼', subIdx);

            // 가용범위 바깥쪽을 클릭했을때 스킵
            if( Util.int(subIdx)<min || max<Util.int(subIdx)) {
                console.log('가용범위 바깥쪽');
                return;
            }

            // console.log(11);
            const arr = self.subIdxList;
            let fr = Math.min(...arr); // 서브버튼 선택한 인덱스 최소값
            let to = Math.max(...arr); // 서브버튼 선택한 인덱스 최대값
            console.log('currentRange', fr, to);
            console.log('subFunc', subFunc);
            if( subFunc=='toggle') {
                self.clickToggleFunc(String(subIdx));
            }else{
                // 기존 범위보다 큰걸 선택했다면
                if( Util.int(subIdx)>Util.int(to)) {
                    to=Util.int(subIdx);
                }
                // 기존 범위보다 작은걸 선택했다면
                else if( Util.int(subIdx)<fr ){
                    fr=Util.int(subIdx);
                    // console.log(33);
                }
                // 기존범위 안쪽일때
                else{
                    [fr, to] = self.clickRangeFunc(subIdx, String(fr), String(to));
                }

                self.subIdxList = self.setIdxRange(fr,to);
            }

            // console.log( self.subIdxList );
            self.win.updateRange();
            self.draw();
            self.showDebug();
            self.calcPrice();
        });
    }
    /**
     * 서브버튼 클릭시 범위선택 방식으로 처리
     * @param subIdx 클릭한버튼의 서브인덱스
     * @param fr 기존에선택했던 서브버튼인덱스의 최소값
     * @param to 기존에선택했던 서브버튼인덱스의 최대값
     * @returns [int,int]
     */
    clickRangeFunc = function(subIdx,fr,to){
        const self = this;
        const arr = this.subIdxList;
        // console.log('subCounter', self.subCounter);
        if( self.subCounter==0 ){ // 맨 처음 눌렀을때
            if( self.data['car_type']=='스카이' ) fr=subIdx; // 스카이는 맨처음 누른게 시작이 된다.
            else {// 스카이 이외는 맨처음 누른게 시작과 동시에 끝이 된다. 즉 한개만 선택이된다.
                fr=subIdx;
                to=subIdx;
            }
        }
        else { // 이후에 누르는 경우
            // 기존에 선택되어있던게 몇개인지 세어보기
            let cnt=0;
            arr.forEach((v)=>{
                if(fr<=v && v<=to) cnt++;
            });

            if( cnt==2 ){// 기존에 2개만 선택되어있었다면 지금누른거 하나만 선택되게
                fr=to=subIdx;
            }
            else{// 기존에 선택된게 2개가 아닐때
                if( Util.int(subIdx) < Util.int(fr) ) fr=subIdx; // 기존범위보다 작은값 선택할경우 그게 시작점이 된다.
                else if( Util.int(subIdx)>Util.int(to)) to=subIdx; // 기존범위보다 큰값을 선택할경우 그게 종료점이 된다.
                else to = subIdx;// 기존범위 안쪽을 선택한경우 종료점이 된다.
            }
        }
        self.subCounter++;
        return [fr,to];
    }
    /**
     * 서브버튼을 클릭시 토글방식으로 처리
     * @param subIdx subIdx 클릭한버튼의 서브인덱스
     */
    clickToggleFunc = function(subIdx){
        console.log('clickToggleFunc', subIdx);
        if( this.subCounter==0 ) { // 맨 처음 눌렀을때
            this.subIdxList = [subIdx];
        }else{// 이후에 눌렀을때
            this.subIdxList = arrayToggle(this.subIdxList,String(subIdx));
        }
        this.subCounter++;
    }
    
    /**
     * 옵션 핸들러
     */
    initOptionHandler = function(){
        const self = this;

        // 버튼식 옵션
        $('#'+this.id+' .option .item').off().on('click',function(){
            self.changeOptionData($(this).data('value'),'button');
            self.calcPrice();

            // TODO : 제약조건 체크
            // alert($(this).data('constraint'));
            const r = self.validate();
            // console.log('validate', r);
            if( !r.result ){
                Util.swalert(r.message);
                return;
            }


        });

        // select 형식 옵션
        $('#'+this.id+' .option select').off().on('change',function(){
            self.changeOptionData($(this).data('value'),'select');
            self.calcPrice();
        });
    }
    /**
     * 옵션에 대한 제약조건 체크
     */
    validate = function(){
        const self = this;
        let isValidate = true;
        let errMsg = '';
        // 옵션들을 순회
        $('#'+this.id+' .option .item,.item-select').each(function(){
        // $('#'+this.id+' .option .item').each(function(){
            console.log('validate', this.tagName);
            if (this.tagName.toLowerCase() == 'select'){// select 형식의 옵션일때
                if(!$(this).val()) return true;// continue
            }else { // 버튼 형식의 옵션일때
                if (!$(this).hasClass('on')) return true; // continue;
            }
            
            /**
             * 제약조건 파싱
             * (1):(2):(3)
             * 1) 조건체크방식 =>  X(유저선택인덱스값들이 3번항목에 부분집합이어야한다), Y(유저선택인덱스값들이 3번항목과 교집합이 있어야하고,첫번째 선택한값이 3번항목중에 있어야한다.)
             * 2) 서브/메인 구분 => M(메인), S(서브)
             * 3) 인덱스번호집합
             * 예제1) X:S:9,15,19 => 유저가 선택한 서브인덱스 집합이 [9,15,19] 의 부분집합이어야 참이다.
             * 예제2) Y:M:8,9,10 => 유저가 선택한 메인인덱스 집합이 [8,9,10] 과 교집합이 존재해야 참이다.
             * 예제3) X:M:3,4 => 돌집게 옵션은 미니,소형에서 이용 할 수 없습니다.
             * 예제4) X:M:3,4 => 코아(천공) 옵션은 미니,소형에서 이용 할 수 없습니다.
             * 예제5) X:S:1,2 => 지하작업은 3톤 / 4.5톤만 가능합니다.
             * 예제6) Y:S:8,9,14,15,19 => 굴절을 선택할 수 있는 차량은 3.5T(26M,28M), 5T(40M,45M), 17T(65M) 차량만 가능합니다.
             */
            const constraint = $(this).data('constraint'); // X:S:9,15,19
            if( !constraint ) return true; // continue
            errMsg = $(this).data('constraint-errmsg');
            const arr = constraint.split(':');
            if(arr.length<3) return true; // continue
            const filter = arr[0];// 조건 체크 방식
            if( !['X','Y'].includes(filter) ) return true; // continue
            const level = arr[1];// 서브/메인 구분
            if(!['M','S'].includes(level)) return true; // continue
            const indexSet = arr[2].split(','); // 인덱스번호집합

            console.log(constraint, filter, level, indexSet);

            let cntY = 0; // 유저가 선택한 값중에 설정집합에 포함되는 개수
            let cntN = 0; // 유저가 선택한 값중에 설정집합에 포함되지 않는 개수
            let firstIdx = 0;// 유저가 선택한 첫번째 인덱스값

            // main 인덱스 순회
            if( level=='M') {
                $('#' + self.id + " .main-button-area .item").each(function () {
                    if( !$(this).hasClass('on') ) return true;// continue;
                    const idx = String($(this).data('index'));
                    if(!idx) return true;// continue
                    // console.log('M',idx);
                    if(!firstIdx) firstIdx=idx;
                    if( indexSet.includes(idx)) cntY++;
                    else cntN++;
                });
            }
            // sub 인덱스 순회
            else if(level=='S'){
                $('#' + self.id + " .sub-button-area .item").each(function () {
                    if( !$(this).hasClass('on') ) return true;// continue;
                    const idx = String($(this).data('index'));
                    if(!idx) return true;// continue
                    // console.log('S',idx);
                    if(!firstIdx) firstIdx=idx;
                    if( indexSet.includes(idx)) cntY++;
                    else cntN++;
                });
            }
            // console.log(`cntY=${cntY}, cntN=${cntN}, firstIdx=${firstIdx}`);

            if( filter=='X'){// 유저가 선택한 인덱스가 설정된집합의 부분집합이어야 한다.
                if( cntN>0 || cntY==0 ) isValidate=false;
            }
            else if( filter=='Y'){// 유저가 선택한 인덱스가 설정된집합과 교집합이 있어야 하고, 유저가선택한 첫번째값이 설정된 집합안에 있어야한다.
                if( cntY==0 ) isValidate=false;
                if( firstIdx>0 && !indexSet.includes(firstIdx)) isValidate=false;
            }

            if( !isValidate) return false;// break
        });

        const r = {
            'result' : isValidate,
            'message': isValidate?'':errMsg
        };
        return r;
    }

    /**
     * 적용 버튼 클릭 핸들러
     * @param prepareFunc 선행작업함수
     */
    initApplyHandler = function(prepareFunc=null){
        const self = this;
        // 완료 버튼을 클릭했을때
        $('#'+this.id+' .apply-data').on('click',function(){

            if( typeof prepareFunc === 'function'){
                if( !prepareFunc(self) ) return;
            }

            const r = self.validate();
            if( !r.result ){
                Util.swalert(r.message);
                return;
            }
            self.apply();
        });
    }

    /**
     * 옵션이 변경 될때 데이터 처리
     * @param optName 옵션명
     * @param optType 옵션종류 (button, select)
     */
    changeOptionData = function(optName, optType){
        if( optType=='button'){
            this.toggleOptionData(optName);
            this.draw();
            this.calcPrice();
        }else{
            this.collectSelectOptionData();
        }

        this.drawOptions();
        this.drawExample();
    }
    /**
     * button 형식 옵션 데이터 업데이트
     * @param opt
     */
    toggleOptionData = function(opt){
        let opts = stringToArray(this.data['car_option']);
        opts = arrayToggle(opts, opt);
        this.data['car_option']=opts.toString();
    }
    /**
     * select 형식 옵션 데이터 업데이트
     */
    collectSelectOptionData = function(){
        const self=this;
        let opts = stringToArray(this.data['car_option']);
        // 기존의 select 옵션을 모두제거한다.
        opts = opts.filter( item => !item.includes('['));

        $('#'+this.id+' .option select').each(function(idx,el){
            const k = $(el).attr('data-value');
            const v = $(el).val();

            if( k=='전고') {
                if(v) self.data['car_height']=v;
            }
            // else if( k=='고릴라') {
            //     if(v) self.data['crain_gorilaset']=v;
            // }
            else if( k=='이동거리') {
                if(v) self.data['move_distance']=v;
            }
            else {
                if( v ) opts.push(`[${v}]`);
            }
        });

        this.data['car_option']=opts.toString();
    }
    /**
     * 완료(적용) 버튼 눌렀을때
     */
    apply = function(){
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
    /**
     * 인덱스 범위를 재설정한다.
     * @param fr
     * @param to
     */
    setIdxRange = function(fr,to){
        const arr = [];
        for(let i=Util.int(fr); i<=Util.int(to);i++){
            arr.push(i.toString());
        }
        return arr;
    }

}


